import React, { useEffect, useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import StatsIllustrationSrc from "images/stats-illustration.svg";
import { ReactComponent as SvgDotPattern } from "images/dot-pattern.svg";
import { useNavigate, useLocation } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import Modal from "react-modal";
import SelectComp from "components/common/Select/SelectComp";
import { useCheckoutInformation } from "components/forms/useCheckoutInformation";
import CheckoutForm from "./CheckoutForm";
import { DUMMY_NEWS_DATA, NEWS_HEADING } from "config/profile_constants";

const customStyles = {
  content: {
    top: "40%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-20%",
    transform: "translate(-40%, -40%)",
    maxHeight: "80vh",
  },
};
export const Container = tw.div`relative`;
export const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
export const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
export const ImageColumn = tw(
  Column
)`md:w-5/12 flex items-center flex-shrink-0 h-80 md:h-auto justify-center relative`;
export const TextColumn = styled(Column)((props) => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:mr-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

export const Image = styled.div((props) => [
  `background-image: url("${props.source}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]);
export const TextContent = tw.div`lg:py-8 text-center md:text-left`;

export const Subheading = tw(SubheadingBase)`text-center md:text-left`;
export const Heading = tw(
  SectionHeading
)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
export const Description = tw.p`text-[14px] mt-4 text-center md:text-left font-medium leading-relaxed text-secondary-100`;

const Statistics = tw.div`flex flex-col items-center sm:block text-center md:text-left mt-4`;
const Statistic = tw.div`text-center items-center sm:inline-block sm:mr-12 last:mr-0 mt-4`;
const ViewButtonWrapper = tw.div`text-center lg:text-left `;
const Value = tw.div`font-bold text-lg sm:text-xl lg:text-2xl text-secondary-500 tracking-wide`;
const Key = tw.div`font-medium text-primary-700`;
const DividerTextContainer = tw.div`my-12 border-b text-center relative`;
const PrimaryButton = tw(
  PrimaryButtonBase
)`mt-8 md:mt-10 text-sm inline-block mx-auto md:mx-0`;

export const DecoratorBlob = styled(SvgDotPattern)((props) => [
  tw`w-20 h-20 absolute right-0 bottom-0 transform translate-x-1/2 translate-y-1/2 fill-current text-primary-500 -z-10`,
]);

export const Input = tw.input`w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5 first:mt-0`;
export const SubmitButton = styled.button`
  ${tw`mt-5 tracking-wide font-semibold bg-primary-500 text-gray-100 w-full py-4 rounded-lg hover:bg-primary-900 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none`}
  .icon {
    ${tw`w-6 h-6 -ml-2`}
  }
  .text {
    ${tw`ml-3`}
  }
`;

export default (data) => {
  console.log("data", data);
  const navigate = useNavigate();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    setIsOpen(false);
  }
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  //Change the statistics variable as you like, add or delete objects
  const defaultStatistics = [
    {
      key: "Total Return",
      value: `${data.data.targetedTotalReturn}`,
    },
    {
      key: "Annual Returns",
      value: `${data.data.targetedAnnualCashYield}`,
    },
    {
      key: "Min Investment",
      value: `${data.data.minimumInvestment}`,
    },
    {
      key: "Investment Period",
      value: `${data.data.investmentPeriod}`,
    },
  ];
  const series = [
    {
      name: "Investment",
      data: [
        100000, 200000, 150000, 150000, 200000, 100000, 200000, 150000, 100000,
      ],
    },
  ];
  const options = {
    chart: {
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
    },
    title: {
      text: "Returns Trends by Month",
      align: "left",
    },
    colors: ["#8403fc"],
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
    },
  };

  return (
    <Container>
      <TwoColumn css={tw`md:items-center`}>
        <ImageColumn>
          <img
            src={data.data.imageSrc}
            loading="lazy"
            alt=""
            width="85%"
            height="400"
          />
        </ImageColumn>
        <TextColumn textOnLeft={false}>
          <TextContent>
            {/* {subheading && <Subheading>{subheading}</Subheading>} */}
            <Subheading>{NEWS_HEADING}</Subheading>
            <Description>
              {DUMMY_NEWS_DATA + " "} {data.data?.title}
            </Description>
            <Heading>{data.data?.title}</Heading>
            <Description>{data.data?.description}</Description>
            <Description>{data.data?.investmentType}</Description>
            <Statistics>
              {defaultStatistics.map((statistic, index) => (
                <Statistic key={index}>
                  <Value>{statistic.value}</Value>
                  <Key>{statistic.key}</Key>
                </Statistic>
              ))}
            </Statistics>
            <PrimaryButton as="a" onClick={openModal}>
              {"Start Investing"}
            </PrimaryButton>
          </TextContent>
        </TextColumn>
      </TwoColumn>
      <ViewButtonWrapper>
        <PrimaryButton as="a" onClick={() => navigate(`/terms`)}>
          {"View Documents"}
        </PrimaryButton>
      </ViewButtonWrapper>
      <DividerTextContainer></DividerTextContainer>
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={200}
      />
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <CheckoutForm />
      </Modal>
    </Container>
  );
};
